/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'menu-files': {
    width: 14,
    height: 12,
    viewBox: '0 0 14 12',
    data: '<path pid="0" d="M12.938 4.44V2.826a.965.965 0 00-.966-.966H6.618L6.283.814a.964.964 0 00-.92-.672h-4.34a.965.965 0 00-.966.966v9.235c0 .049.005.097.012.145l.007.04.002.011.01.033c0 .007.003.014.004.02l.004.017a.434.434 0 00.013.041v.001c.05.145.133.274.242.379l.003.002.03.03c.006.003.011.008.015.012l.015.012.027.022.008.005.033.024.003.001a.95.95 0 00.443.16c.015.001.028.003.043.003H.98l.044.001h10.573c.443 0 .83-.301.938-.73l1.234-4.939a.968.968 0 00-.83-1.192zM1.023 1.109H5.36l.553 1.718h6.06v1.61H2.258a.968.968 0 00-.938.73l-.297 1.192v-5.25zm10.573 9.231H1.024l1.234-4.938H12.83l-1.234 4.938z" _fill="#606266" fill-rule="nonzero"/>'
  }
})
